import type { RequestOptions } from '@@/plugin-request/request';

export type ApiRequestOptions = RequestOptions;

export type JsonObject = Record<string, unknown>;

export interface ApiResponse<T> {
  code: number;
  msg: string;
  data: T | null;
}

export function unwrapApiResponse<T>(response: ApiResponse<T>): T {
  if (response?.code !== 200) {
    throw new Error(response?.msg || '请求失败');
  }
  if (response.data === undefined || response.data === null) {
    throw new Error('服务返回数据为空');
  }
  return response.data;
}
